import CustomLoading from '@/components/custom-loading';
import LocalStorage from '@/lib/local-storage';
import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

const CheckAuthPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (!searchParams.get('token')) {
      navigate('/warning-login');
      return;
    }
    LocalStorage.setToken(searchParams.get('token') || '');
    navigate(`/gift-card`);
  }, [searchParams.get('token')]);

  return (
    <>
      <div className="fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
        <CustomLoading />
      </div>
    </>
  );
};

export default CheckAuthPage;
